import { get } from 'lodash';
import React from 'react';

const BasicData = ({ data, userNickname }) => {
  if (!data) return;
  const nickname = data.username || userNickname;

  return (<React.Fragment>
    {nickname && <h6 className='text-break'> {`@${nickname}`} </h6>}
    <div className="text-2">
      {get(data, 'stats.bio')}
    </div>
  </React.Fragment >);
};

export default React.memo(BasicData);